import { render, staticRenderFns } from "./SampleTypeCard.vue?vue&type=template&id=3f60176b"
import script from "./SampleTypeCard.vue?vue&type=script&lang=js"
export * from "./SampleTypeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports